import PreviewListImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Template';

const routes = [
	{
		matchRegex: '/Template',
		name: getRouteName(MODULE_NAME, 'Home'),
		slots: [SLOT_KEY.SLOT_TAB, SLOT_KEY.SLOT_V_SECTION],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }]
		}
	}
];

export default routes;
